module.exports = __webpack_public_path__ + "img/122.31826aa5.jpg";